import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Container } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import type { ConfigType } from '../../types/configuration';

interface props {
    earliestDate: string;
    latestDate: string;
    handleChange: any;
    customParams: any;
    valueToDisplay?: 'start' | 'end';
    timezone?: string;
    config?: ConfigType;
    disabled?: boolean;
}

const DateTimePicker = ({ earliestDate, handleChange, customParams, latestDate, valueToDisplay, timezone = 'Europe/London', config, disabled = false }: props) => {
    const [minDate, setMinDate] = useState(moment());
    const [maxDate, setMaxDate] = useState(moment());
    const [dateValue, setDateValue] = useState(moment());
    const wmGen = !!config;

    const getEffectiveMinDate = () => {
        const now = moment().tz(timezone);
        const configStart = wmGen ? moment(config.configurationParameters.configurationStartUtc).tz(timezone) : null;
        const startBoundary = configStart ? moment.max(now, configStart) : now;

        if (valueToDisplay === 'end') {
            return moment.max(startBoundary, minDate);
        }

        return startBoundary;
    };

    const getEffectiveMaxDate = () => {
        const configEnd = wmGen ? moment(config.configurationParameters.configurationEndUtc).tz(timezone) : null;

        if (valueToDisplay === 'start') {
            return configEnd ? moment.min(maxDate, configEnd) : maxDate;
        }

        return configEnd || maxDate;
    };

    useEffect(() => {
        if (earliestDate !== '' && latestDate !== '') {
            const initialMinDate = moment(earliestDate);
            setMinDate(initialMinDate);
            const initialMaxDate = moment(latestDate);
            setMaxDate(initialMaxDate);
            valueToDisplay === 'start' ? setDateValue(initialMinDate) : setDateValue(initialMaxDate);
        }
    }, [earliestDate, latestDate, valueToDisplay]);

    return (
        <Container className='datetimeContainer' disableGutters>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='en-US'>
                <DesktopDateTimePicker
                    timezone={timezone}
                    disabled={disabled}
                    minDateTime={getEffectiveMinDate()}
                    maxDateTime={getEffectiveMaxDate()}
                    disablePast={true}
                    value={dateValue}
                    onChange={(dateValue) =>
                        handleChange({ date: dateValue, ...customParams })
                    }
                    ampm={false}
                    ampmInClock={false}
                    slots={{
                        openPickerIcon: ArrowDropDownIcon,
                    }}
                    slotProps={{
                        textField: {
                            size: 'small',
                            className: 'input-text',
                            inputProps: {
                                style: { fontSize: '13px' },
                            },
                        },
                    }}
                />
            </LocalizationProvider>
        </Container>
    );
};
export { DateTimePicker };
